import { render, staticRenderFns } from "./SwitchTenantDialog.vue?vue&type=template&id=45aa796a&scoped=true&"
import script from "./SwitchTenantDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchTenantDialog.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTenantDialog.vue?vue&type=style&index=0&id=45aa796a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa796a",
  null
  
)

export default component.exports